module.exports = __webpack_public_path__ + "static/media/cap.86eef4bd.svg";